/**
 * Нумерация партий плана готовой продукции общей смены.
 * Чистая функция — вызывается из ShiftCustomPlanForm.onEquipmentChange,
 * покрыта unit-тестами (tests/unit/batch-number.spec.ts).
 */

/**
 * Номер партии новой записи плана ГП.
 * С оборудованием: «Префикс + буква времени суток + -NN» (КД-01, А160Н-01),
 * где NN — количество планов смены с этим оборудованием + 1, двузначное
 * (10-я партия — «-10»).
 * Без оборудования (или без префикса): прежний формат — порядковый номер
 * по смене + первая буква времени суток (1Д, 2Н).
 */
export function buildEquipmentBatchNumber(
  equipment: { id: any; prefix?: string | null } | null | undefined,
  relatedPlansList: any[],
  relTimeOfDay: string | null | undefined,
): string {
  const letter = relTimeOfDay ? relTimeOfDay[0] : '';

  if (!equipment || !equipment.prefix) {
    return (relatedPlansList.length + 1) + letter;
  }

  const seq = relatedPlansList.filter((plan: any) => {
    return plan.equipment_id == equipment.id;
  }).length + 1;

  return `${equipment.prefix}${letter.toUpperCase()}-${String(seq).padStart(2, '0')}`;
}
